<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import {
    getSvelteContext,
    type MapGeoJSONFeature,
    type MapLayerMouseEvent,
    type MapMouseEvent,
  } from "./mapping";

  import type { VectorGLMap } from "./mapping";
  const eventing = createEventDispatcher();

  const { styledmap } = getSvelteContext();
  let MAP: VectorGLMap;

  export let filter:
    | any[]
    | ((feature: MapGeoJSONFeature | GeoJSON.Feature) => Boolean) = null;
  let layer: string | null = null;

  function click(features: MapGeoJSONFeature[]) {
    for (const feature of features) {
      eventing("click", feature);
    }
  }

  function onclick(e: MapMouseEvent) {
    console.log("mapfeatureclick.click=", e);
    const features = e.target
      .queryRenderedFeatures(
        e.point,
        filter instanceof Function
          ? undefined
          : {
              filter,
            }
      )
      .filter(filter instanceof Function ? filter : () => true);
    console.log("mapfeatureclick.click=", e, features, filter);

    click(features);
  }

  function init($map: VectorGLMap, $layer?: string) {
    cleanup($layer); // cleanup previous map
    MAP = $map; // set

    // events
    if ($layer) {
      MAP?.on("click", $layer, onclick);
    } else {
      MAP?.on("click", onclick);
    }
  }
  function cleanup($layer?: string) {
    if (!MAP) return; // no map to cleanup

    // events
    if ($layer) MAP?.off("click", $layer, onclick);
    MAP?.off("click", onclick);

    MAP = null; //set
  }

  $: init($styledmap, layer);

  onMount(function () {
    //const unsubscribe = map.subscribe(init);
    return function destroy() {
      cleanup(layer);
      //unsubscribe();
    };
  });
</script>

<slot />
